import * as React from "react";
import { Typography } from "@mui/material";
import { TextPluralization } from "components/TextPluralization";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { useTranslation } from 'react-i18next';

interface IProps {
    count: number;
    additionalInfo?: string | React.ReactElement;
    singularText?: string;
    pluralText?: string;
    emptyText?: string;
}

type Props = IProps;

const FilterCountInfo: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    return (
        <Typography variant="subtitle2" component="span">
            <MuiColor variant="muted">
                <b>
                    {props.count > 0 ? props.count : props.emptyText}
                </b>
                {
                    props.count > 0 &&
                    <>
                        &nbsp;
                        <TextPluralization
                            singular={props.singularText || t("Common.Filter.ResultText")}
                            plural={props.pluralText || t("Common.Filter.ResultText_plural")}
                            count={props.count}
                        />
                        {
                            props.additionalInfo &&
                            <>&nbsp;{props.additionalInfo}</>
                        }
                    </>
                }
            </MuiColor>
            {props.children}
        </Typography>
    );
};

export default FilterCountInfo;
